import { render, staticRenderFns } from "./IntegerParameter.vue?vue&type=template&id=47b4c5f4&"
import script from "./IntegerParameter.vue?vue&type=script&lang=ts&"
export * from "./IntegerParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports